import { useCallback, useEffect, useState } from "react";
import ProfileService from "../../services/profile.service";
import { Button, Form, Input, Modal, Select } from "antd";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { profileDetailsSelector } from "../../store/selectors/app.selector";
import { allowOnlyAlphaNumerics } from "../../services/common.service";
import BANK_LOGO from "client/assets/LOGO/BANK_LOGO.png";
import { ReactComponent as TickIcon } from "../../assests/images/tickIcon.svg";
import { useTranslation } from "react-i18next";
import PerfectScrollbar from "react-perfect-scrollbar";

const buttonPaths = {
  Dashboard: "/dashboard",
  Accounts: "/accounts",
  "Term Deposits": "/dashboard",
  Payments: "/dashboard",
  "Credit Cards": "/dashboard",
  Insurance: "/dashboard",
  Loans: "/dashboard",
  Services: "/dashboard",
};

export default function SecurityQuestions() {
  const [dataSource, setDataSource] = useState([]);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");
  const location = useLocation();
  const selectedButton = location.state?.selectedButton ?? "Dashboard";
  const selectedPath = buttonPaths[selectedButton];
  const profileDetails = useSelector(profileDetailsSelector);
  const [avilableOption, setAvailableOptions] = useState([]);
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    getQestionsAndAnswer();
  }, []);

  useEffect(() => {
    const initialOptions = dataSource.map((option) => option.question);
    setAvailableOptions([...initialOptions]);
  }, [dataSource]);

  const handleQuestionChange = useCallback(
    (questionIndex, selectedQuestion) => {
      setSelectedQuestions((prevSelectedQuestions) => {
        const updatedQuestions = [...prevSelectedQuestions];
        const previousQuestion = updatedQuestions[questionIndex];
        if (previousQuestion) {
          setAvailableOptions((prevAvailableOptions) => [
            ...prevAvailableOptions,
            previousQuestion,
          ]);
        }
        setAvailableOptions((prevAvailableOptions) =>
          prevAvailableOptions.filter((option) => option !== selectedQuestion)
        );
        updatedQuestions[questionIndex] = selectedQuestion;
        return updatedQuestions.filter(Boolean);
      });
    },
    []
  );

  const getQestionsAndAnswer = useCallback(async () => {
    try {
      const response = await ProfileService.getQestionsAndAnswer();
      if (response.status === 200) {
        response.data["data"].forEach((element) => {
          element.answer = "";
        });
        setDataSource(response.data["data"] || []);
      }
    } catch (error) {}
  }, []);

  const handleSkip = useCallback(async () => {
    try {
      const response = await ProfileService.setQestionsSkip();
      if (response.status === 200) {
        if (selectedPath) {
          navigate(selectedPath);
        }
      }
    } catch (error) {}
  }, []);

  const handleSubmit = useCallback(
    async (values) => {
      try {
        let errorCount = 0;

        if (
          values.question1 === undefined &&
          values.question2 === undefined &&
          values.question3 === undefined &&
          values.question4 === undefined &&
          values.question5 === undefined
        ) {
          return;
        }

        // dataSource.forEach((element) => {
        //   if (element.answer.trim().length > 0) {
        //     errorCount += 1;
        //   }
        // });
        // if (errorCount < 3) {
        //   console.log(errorCount);
        //   return;
        // }

        const reqParams = [
          {
            question: values.question1,
            answer: values.answer1,
          },
          {
            question: values.question2,
            answer: values.answer2,
          },
          {
            question: values.question3,
            answer: values.answer3,
          },
          // {
          //   question: values.question4,
          //   answer: values.answer4,
          // },
          // {
          //   question: values.question5,
          //   answer: values.answer5,
          // },
        ];

        const response = await ProfileService.setQestions(reqParams);
        if (response.status === 200) {
          setMessage(response.data["message"]);
          setShowModal(true);
        }
      } catch (error) {}
    },
    [dataSource]
  );

  return (
    <>
      <div className="h-100">
        <div align="center" className="mb-4">
          <img src={BANK_LOGO} height={35} />
        </div>
        <PerfectScrollbar>
        <div className="login-container security-questions-container" style={{ overflow: "auto" }}>
          <h5>
            {t("pages.security_questions.sec_qus_title", {
              defaultValue: "Please answer the questions",
            })}
          </h5>
          <p
            className="text-left secondary_txt_color_two"
            style={{ fontSize: "13px" }}
          >
            {t("pages.security_questions.sec_qus_desc", {
              defaultValue:
                "Please refrain from using spaces or special characters in your answers",
            })}
          </p>

          <Form layout="vertical" onFinish={handleSubmit}>
            <div style={{ borderBottom: "1px solid #d9d9d9" }} className="mt-1">
              <Form.Item
                label={t("pages.security_questions.qus1", {
                  defaultValue: "Question 1",
                })}
                name="question1"
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.question_require", {
                      defaultValue: "Question is required",
                    }),
                  },
                ]}
              >
                <Select
                  placeholder={t("pages.security_questions.qus", {
                    defaultValue: "Question",
                  })}
                  size="large"
                  onChange={(value) => {
                    handleQuestionChange(0, value);
                  }}
                >
                  {avilableOption.map((option, idx) => (
                    <Select.Option key={idx} value={option}>
                      {option}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label=""
                name="answer1"
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.answer_require", {
                      defaultValue: "Answer is required",
                    }),
                  },
                ]}
              >
                <Input
                  onKeyPress={(e) => allowOnlyAlphaNumerics(e)}
                  placeholder={t("pages.security_questions.answer", {
                    defaultValue: "Answer",
                  })}
                  maxLength={20}
                  size="large"
                />
              </Form.Item>
            </div>
            <div style={{ borderBottom: "1px solid #d9d9d9" }} className="mt-3">
              <Form.Item
                label={t("pages.security_questions.qus2", {
                  defaultValue: "Question 2",
                })}
                name="question2"
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.question_require", {
                      defaultValue: "Question is required",
                    }),
                  },
                ]}
              >
                <Select
                  placeholder={t("pages.security_questions.qus", {
                    defaultValue: "Question",
                  })}
                  size="large"
                  onChange={(value) => {
                    handleQuestionChange(1, value);
                  }}
                >
                  {avilableOption.map((option, idx) => (
                    <Select.Option key={idx} value={option}>
                      {option}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label=""
                name="answer2"
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.answer_require", {
                      defaultValue: "Answer is required",
                    }),
                  },
                ]}
              >
                <Input
                  onKeyPress={(e) => allowOnlyAlphaNumerics(e)}
                  placeholder={t("pages.security_questions.answer", {
                    defaultValue: "Answer",
                  })}
                  maxLength={20}
                  size="large"
                />
              </Form.Item>
            </div>
            <div style={{ borderBottom: "1px solid #d9d9d9" }} className="mt-3">
              <Form.Item
                label={t("pages.security_questions.qus3", {
                  defaultValue: "Question 3",
                })}
                name="question3"
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.question_require", {
                      defaultValue: "Question is required",
                    }),
                  },
                ]}
              >
                <Select
                  placeholder={t("pages.security_questions.qus", {
                    defaultValue: "Question",
                  })}
                  size="large"
                  onChange={(value) => handleQuestionChange(2, value)}
                >
                  {avilableOption.map((option, idx) => (
                    <Select.Option key={idx} value={option}>
                      {option}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label=""
                name="answer3"
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.answer_require", {
                      defaultValue: "Answer is required",
                    }),
                  },
                ]}
              >
                <Input
                  onKeyPress={(e) => allowOnlyAlphaNumerics(e)}
                  placeholder={t("pages.security_questions.answer", {
                    defaultValue: "Answer",
                  })}
                  maxLength={20}
                  size="large"
                />
              </Form.Item>
            </div>

            {/* <div style={{ borderBottom: "1px solid #d9d9d9" }} className="mt-3">
              <Form.Item
                label="Question 4"
                name="question4"
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.question_require", {
                      defaultValue: "Question is required",
                    }),
                  },
                ]}
              >
                <Select
                  placeholder={t("pages.security_questions.qus", {
                    defaultValue: "Question",
                  })}
                  size="large"
                  onChange={(value) => handleQuestionChange(4, value)}
                >
                  {avilableOption.map((option, idx) => (
                    <Select.Option key={idx} value={option}>
                      {option}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label=""
                name="answer4"
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.answer_require", {
                      defaultValue: "Answer is required",
                    }),
                  },
                ]}
              >
                <Input
                  onKeyPress={(e) => allowOnlyAlphaNumerics(e)}
                  placeholder={t("pages.security_questions.answer", {
                    defaultValue: "Answer",
                  })}
                  maxLength={20}
                  size="large"
                />
              </Form.Item>
            </div>
            <div className="mt-3">
              <Form.Item
                label="Question 5"
                name="question5"
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.question_require", {
                      defaultValue: "Question is required",
                    }),
                  },
                ]}
              >
                <Select
                  placeholder={t("pages.security_questions.qus", {
                    defaultValue: "Question",
                  })}
                  size="large"
                  onChange={(value) => handleQuestionChange(5, value)}
                >
                  {avilableOption.map((option, idx) => (
                    <Select.Option key={idx} value={option}>
                      {option}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                label=""
                name="answer5"
                rules={[
                  {
                    required: true,
                    message: t("errorMesssages.answer_require", {
                      defaultValue: "Answer is required",
                    }),
                  },
                ]}
              >
                <Input
                  onKeyPress={(e) => allowOnlyAlphaNumerics(e)}
                  placeholder={t("pages.security_questions.answer", {
                    defaultValue: "Answer",
                  })}
                  maxLength={20}
                  size="large"
                />
              </Form.Item>
            </div> */}
            <div className="mt-3 mb-5 d-flex justify-content-between">
              {/* {profileDetails?.skipSecurityQuestions && (
                <Button
                  className="secondary-btn"
                  style={{ width: 100 }}
                  onClick={() => handleSkip()}
                  type="default"
                >
                  {t("buttons.skip_btn", {
                    defaultValue: "Skip",
                  })}
                </Button>
              )} */}
              <div></div>
              <Button
                // style={{ width: 140 }}
                type="primary"
                size="large"
                block
                className="primary-btn button-style-curve"
                htmlType="submit"
              >
                {t("buttons.submit_btn", {
                  defaultValue: "Submit",
                })}
              </Button>
            </div>
          </Form>
        </div>
        </PerfectScrollbar>
      </div>
      <Modal
        open={showModal}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        className="custom-error-modal"
      >
        <div style={{   margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 100 }}
              onClick={() => {
                setShowModal(false);
                if (selectedPath) {
                  navigate(selectedPath);
                }
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
